import { useEffect } from 'react';

import { isMobile } from 'react-device-detect';
import { create } from 'zustand';

type MobileStoreProps = {
  isMobile: boolean;
  setIsMobile: (isMobile: boolean) => void;
};

export const useMobileStore = create<MobileStoreProps>(set => ({
  isMobile: false,
  setIsMobile: (isMobile: boolean) => set({isMobile}),
}));

export const useIsMobile = () => {
  return useMobileStore(state => state.isMobile);
};

export const useMobileClass = () => {
  const setIsMobile = useMobileStore(state => state.setIsMobile);

  useEffect(() => {
    const reportWindowSize = () => {
      if (isMobile) {
        setIsMobile(true);

        return;
      }

      if (!('matchMedia' in window)) {
        return;
      }

      const result = window.matchMedia('(max-width: 1000px)').matches;

      if (result) {
        document.documentElement.classList.add('mobile');
        document.documentElement.classList.remove('desktop');

        setIsMobile(true);
      } else {
        document.documentElement.classList.add('desktop');
        document.documentElement.classList.remove('mobile');

        setIsMobile(false);
      }
    };

    reportWindowSize();

    window.addEventListener('resize', reportWindowSize);

    return () => {
      window.removeEventListener('resize', reportWindowSize);
    };
  }, [setIsMobile]);
};
